import Layout from '../../../Components/Layout/Layout';
import { Container, Card, Button } from 'react-bootstrap';
import './SuccessPayment.css';
import { BsCheckCircleFill } from 'react-icons/bs';
import { Link, useSearchParams } from 'react-router-dom';

const SuccessPayment = () => {
  const [searchParams] = useSearchParams();
  const type = searchParams.get('user_type') as 'B2B' | 'Exhibitor' | 'Visitor';

  return (
    <Layout showHeader>
      <Container className='success-wrapper d-flex justify-content-center align-items-center'>
        <Card
          className='success-card text-center p-4 shadow-lg'
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <BsCheckCircleFill className='success-icon mb-3' />

          <h3 className='success-title'>Payment Successful!</h3>
          <p className='success-text'>
            Thank you! Your transaction has been completed successfully.
          </p>

          <Link
            to={
              type === 'Visitor'
                ? '/visitor/profile'
                : type === 'B2B'
                ? '/b2b/profile'
                : `/profile`
            }
            style={{ width: '100%' }}
          >
            {' '}
            <Button variant='primary' className='mt-3 common-btn submit-button'>
              Go Back
            </Button>
          </Link>
        </Card>
      </Container>
    </Layout>
  );
};

export default SuccessPayment;
